import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login, register } = useAuth();
  const [tab, setTab] = useState('login');
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [pendingApproval, setPendingApproval] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      if (tab === 'login') {
        await login(form.username, form.password);
      } else {
        const result = await register(form.username, form.password);
        if (result?.pendingApproval) {
          setPendingApproval(true);
        }
      }
    } catch (err) {
      setError(err.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  if (pendingApproval) {
    return (
      <div style={s.page}>
        <div style={s.card} className="animate-slideup">
          <div style={s.logo}>
            <div style={s.logoCircle}>🏓</div>
            <h1 style={s.title}>Live Pickle Ball</h1>
          </div>
          <div style={s.pendingBox}>
            <div style={s.pendingIcon}>⏳</div>
            <h2 style={s.pendingTitle}>Account Request Submitted</h2>
            <p style={s.pendingText}>
              Your admin account request has been submitted successfully. The super admin will review
              your request and approve your account. You will be able to log in once approved.
            </p>
            <button
              className="btn btn-primary"
              style={{ width: '100%', marginTop: '16px' }}
              onClick={() => { setPendingApproval(false); setTab('login'); setForm({ username: '', password: '' }); }}
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={s.page}>
      <div style={s.card} className="animate-slideup">
        <div style={s.logo}>
          <div style={s.logoCircle}>🏓</div>
          <h1 style={s.title}>Live Pickle Ball</h1>
          <p style={s.subtitle}>Pickle Ball Tournament Manager</p>
        </div>

        <div style={s.tabs}>
          {['login', 'register'].map(t => (
            <button
              key={t}
              style={{ ...s.tab, ...(tab === t ? s.tabActive : {}) }}
              onClick={() => { setTab(t); setError(''); }}
            >
              {t === 'login' ? 'Login' : 'Request Access'}
            </button>
          ))}
        </div>

        {tab === 'register' && (
          <div style={s.infoBox}>
            New admin accounts require super admin approval before you can log in.
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              className="form-control"
              type="email"
              placeholder="admin@example.com"
              value={form.username}
              onChange={e => setForm(f => ({ ...f, username: e.target.value }))}
              required
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              className="form-control"
              type="password"
              placeholder="Enter password"
              value={form.password}
              onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
              required
            />
          </div>
          {error && <div style={s.error}>{error}</div>}
          <button className="btn btn-primary btn-lg" style={{ width: '100%' }} disabled={loading}>
            {loading ? 'Please wait...' : tab === 'login' ? 'Login' : 'Submit Request'}
          </button>
        </form>
      </div>
    </div>
  );
}

const s = {
  page: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'linear-gradient(135deg, #1a2332 0%, #2c3e50 50%, #1e8449 100%)',
    padding: '20px',
  },
  card: {
    background: '#fff', borderRadius: '16px', padding: '40px',
    width: '100%', maxWidth: '400px', boxShadow: '0 24px 64px rgba(0,0,0,0.2)',
  },
  logo: { textAlign: 'center', marginBottom: '28px' },
  logoCircle: {
    width: '72px', height: '72px', borderRadius: '50%',
    background: 'linear-gradient(135deg, #27ae60, #1e8449)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '36px', margin: '0 auto 12px',
    boxShadow: '0 8px 24px rgba(39,174,96,0.4)',
  },
  title: { fontSize: '28px', fontWeight: '800', color: '#1a2332' },
  subtitle: { fontSize: '14px', color: '#7f8c8d', marginTop: '4px' },
  tabs: {
    display: 'flex', gap: '4px', background: '#f0f4f8',
    borderRadius: '8px', padding: '4px', marginBottom: '16px',
  },
  tab: {
    flex: 1, padding: '9px', borderRadius: '6px', fontSize: '14px', fontWeight: '600',
    background: 'transparent', color: '#7f8c8d', cursor: 'pointer', border: 'none', transition: 'all 0.2s',
  },
  tabActive: { background: '#fff', color: '#27ae60', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' },
  infoBox: {
    background: '#f0f9f4', border: '1px solid #a9dfbf', borderRadius: '6px',
    padding: '10px 14px', color: '#1e8449', fontSize: '13px', marginBottom: '16px',
  },
  error: {
    background: '#fdf2f2', border: '1px solid #e74c3c', borderRadius: '6px',
    padding: '10px 14px', color: '#e74c3c', fontSize: '13px', marginBottom: '16px',
  },
  pendingBox: { textAlign: 'center' },
  pendingIcon: { fontSize: '48px', marginBottom: '12px' },
  pendingTitle: { fontSize: '20px', fontWeight: '700', color: '#1a2332', marginBottom: '12px' },
  pendingText: { fontSize: '14px', color: '#7f8c8d', lineHeight: '1.6' },
};
